/* global axios */
import ApiClient from './ApiClient';

class UnhappyCasesAPI extends ApiClient {
  constructor() {
    super('unhappy_cases', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  trust(id) {
    return axios.patch(`${this.url}/${id}/trust`);
  }

  untrust(id) {
    return axios.patch(`${this.url}/${id}/untrust`);
  }

  createNote(unhappyCaseId, content) {
    return axios.post(`${this.url}/${unhappyCaseId}/notes`, { content });
  }

  updateNote(unhappyCaseId, noteId, content) {
    return axios.patch(`${this.url}/${unhappyCaseId}/notes/${noteId}`, {
      content,
    });
  }

  deleteNote(unhappyCaseId, noteId) {
    return axios.delete(`${this.url}/${unhappyCaseId}/notes/${noteId}`);
  }

  bulkUpdate(ids, reviewStatus) {
    return axios.post(`${this.url}/bulk_update`, {
      ids,
      review_status: reviewStatus,
    });
  }

  // Reports (V2)
  reportSummary(params = {}) {
    return axios.get(this.reportsUrl('summary'), { params });
  }

  reportTimeseries(params = {}) {
    return axios.get(this.reportsUrl('timeseries'), { params });
  }

  reportBreakdown(params = {}) {
    return axios.get(this.reportsUrl('breakdown'), { params });
  }

  reportsUrl(endpoint) {
    return `/api/v2/accounts/${this.accountIdFromRoute}/unhappy_cases_reports/${endpoint}`;
  }
}

export default new UnhappyCasesAPI();
